const setting = {
  state: {
    uploadUrl: process.env.VUE_APP_BASE_API + "/api/v1/public/uploadfile", //上传文件的路径
    trainDefaultImg: ""
  },
  mutations: {
    setTrainDefaultImg(state, data) {
      state.trainDefaultImg = data;
    }
  },
  actions: {}
};

export default setting;
